<template>
  <div>
    <Input
      label="global.groupName"
      v-model="form.cn"
      :defaultValue="selectedItem.cn"
      :state="validateState('cn')"
    />

    <Input
      label="global.description"
      v-model="form.description"
      :defaultValue="selectedItem.description"
    />

    <b-form-group :label="$t('global.member')">
      <multiselect
        id="member"
        v-model="form.member"
        :options="memberList"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('global.member')"
        :loading="loading"
        track-by="dn"
        :custom-label="customMemberListLabel"
        :limit="3"
        :show-no-results="false"
        :state="validateState('member')"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'GroupForm',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedItem: String | Object,
  },
  data() {
    return {
      loading: false,
      form: {
        cn: '',
        description: '',
        member: '',
      },
      memberList: [],
    }
  },
  validations: {
    form: {
      cn: {
        required,
      },
      description: {
        required,
      },
      member: {
        required,
      },
    },
  },
  created() {
    this.getMemberList()
  },
  methods: {
    getMemberList() {
      this.loading = true
      this.getMembers()
        .then((res) => {
          this.memberList = res.data
          this.loading = false
        })
        .catch(() => {
          this.memberList = []
        })
    },
    getMembers() {
      return new Promise((resolve, reject) => {
        let query = `iam/${this.$route.params.id}/people?position=id|desc`

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    customMemberListLabel({ cn, mail }) {
      return `${cn ? cn : ''} ${mail ? ' - ' + mail : ''}`
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        cn: this.form.cn,
        description: this.form.description,
        member: this.form.member.dn,
      }

      this.insertOperation(params)
    },
    insertOperation(params) {
      ApiService.post(`iam/${this.$route.params.id}/groups`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.formReset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    // updateOperation(params) {
    //   ApiService.put(
    //     `iam/${this.$route.params.id}/groups/${this.selectedItem.dn}`,
    //     params
    //   )
    //     .then(({ data }) => {
    //       this.$generateToast(this, 'success', this.$t('global.successful'))
    //       this.$emit('resetDetailForm', true)
    //       this.$v.$reset()
    //     })
    //     .catch((err) => {
    //       this.$generateToast(this, 'danger', err.message, true)
    //       this.$emit('resetDetailForm', false)
    //     })
    // },
    formReset() {
      this.$v.$reset()
      this.form.cn = ''
      this.form.description = ''
      this.form.member = ''
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    selectedItem(newVal) {
      this.formReset()
    },
  },
}
</script>
